import React, { Component } from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown as PrimeDropdown } from "primereact/components/dropdown/Dropdown";
import HoverableDescriptionBox from "../../../../../components/hoverable-desc-box/HoverableDescriptionBox";
import { NumberInput, TextInput } from "../../../../../components";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import InsuranceDocuments from "../../InsuranceDocuments";
import EnumCoPayUnit from "../../../enums/EnumCoPayUnit";
import DirectBillingItemStatusEnum from "../../../enums/DirectBillingItemStatusEnum";
import DirectBillingItemAuthorizationStatusEnum from "../../../enums/DirectBillingItemAuthorizationStatusEnum";
import { Button, Col, Dropdown, Row, SplitButton } from "react-bootstrap";
import { FormField } from "../../../../../components/form";
import ValidationUtil from "../../../../../components/form/validator/ValidationUtil";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dialog from "../../../../../components/dialog/Dialog";
import {AutoComplete} from "primereact/autocomplete";
import EnumDirectBillingType from "../../direct/EnumDirectBillingType";
import ReferralV2ItemObservationsModal from "../observation/ReferralV2ItemObservationsModal";
import ViewObservationsModalV2 from "../observation/ViewObservationsModalV2";
import ReferralV2ItemResubmissionsModal from "../resubmission/ReferralV2ItemResubmissionsModal";
import VersionModalV2 from "../component/VersionModalV2";

export default class ReferralItemModal extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            referralItems: props.referral?.items || [],
            selectedItems: [],
            cptSearchVisible: false,
            cptSuggestions: [],
        };
    }

    updateReferralItem = (item, updatedField, newValue) => {
        const updatedItems = this.state.referralItems.map(refItem =>
            refItem.id === item.id
                ? { ...refItem, [updatedField]: newValue }
                : refItem
        );
        this.setState({ referralItems: updatedItems });
        if (this.props.onItemsChange) {
            this.props.onItemsChange(updatedItems);
        }
    }

    handleSelectionChange = (e) => {
        this.setState({ selectedItems: e.value });
    }

    handleConfirmSelected = () => {}

    handleDeleteSelected = () => {
        const remaining = this.state.referralItems.filter(
            i => !this.state.selectedItems.includes(i)
        );
        this.setState({ referralItems: remaining, selectedItems: [] });
        this.props.onItemsChange(remaining);
    }

    handleSubmitPriorRequest = () => {
        const { referral } = this.props;
        const ids = this.state.selectedItems.map(i => i.id);
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/integration/referral/${referral.id}/prior-request`, ids,
            () => this.setState({ selectedItems: [] })
        );
    }

    handleExtendPriorRequest = () => {
        const { referral } = this.props;
        const ids = this.state.selectedItems.map(i => i.id);
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/integration/referral/${referral.id}/extend-prior-request`, ids,
            () => this.setState({ selectedItems: [] })
        );
    }

    handleCancelPriorRequest = () => {
        const { referral } = this.props;
        const ids = this.state.selectedItems.map(i => i.id);
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/integration/referral/${referral.id}/cancel-prior-request`, ids,
            () => this.setState({ selectedItems: [] })
        );
    }

    handleSubmitNewRequest = () => {
        const { referral } = this.props;
        const ids = this.state.selectedItems.map(i => i.id);
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/integration/referral/${referral.id}/submit-new-request`, ids,
            () => this.setState({ selectedItems: [] })
        );
    }

    handleCptSearch = (event) => {
        const { referral } = this.props;
        const specialityName = EnumDirectBillingType[referral.speciality]?.name;
        RemotingService.getRemoteCall(
            `api/cpt/list-external-referral/${referral.patient.id}`,
            { code: event.query, speciality: specialityName },
            (results) => this.setState({ cptSuggestions: results || [] })
        );
    }

    handleCptSelected = (event) => {
        const cpt = event.value;
        const newItem = {
            cpt,
            noOfRequestedSessions: 1,
            noOfApprovedSessions: 0,
            coPay: null,
            coPayUnit: null,
            status: null,
            authorizationStatus: null,
            denialCode: null,
            claimFormStatus: null,
            medicalReportStatus: null,
        };
        const updated = [...this.state.referralItems, newItem];
        this.setState({ referralItems: updated, cptSearchVisible: false, cptSuggestions: [] });
        this.props.onItemsChange(updated);
    }

    validate = () => ValidationUtil.checkWithNotification(this.formFields);

    isItemUnauthorized = (item) => {
        const sessions = item.noOfApprovedSessions;
        return sessions != null && sessions !== "" && Number(sessions) === 0;
    };

    // Automation methods - adapted from ReferralAutomationTab
    openObservationsDialog = (item) => {
        const { readOnly } = this.props;
        if (item && item.id) {
            dialog({
                title: "Observations",
                component: <ReferralV2ItemObservationsModal referralItemId={item.id} referralId={this.props.referral?.id} readOnly={readOnly}/>
            });
        }
    }

    openResubmissionsDialog = (item) => {
        if (item && item.id) {
            dialog({
                title: "Resubmissions",
                component: <ReferralV2ItemResubmissionsModal referralItemId={item.id}/>
            });
        }
    }

    openObservationFromInsuranceDialog = (item) => {
        if (item && item.id) {
            RemotingService.getRemoteCall(
                `api/insurance/coordinator/v2/referral-item/${item.id}/observation-from-insurance`, 
                null, 
                observations => {
                    dialog({
                        title: "Observations From Insurance",
                        component: <ViewObservationsModalV2 observations={observations}/>
                    });
                }
            );
        }
    }

    // The files are large, so they are loaded only when a list is opened
    openVersionsDialog = (item, kind, title) => {
        const referralId = this.props.referral?.id;
        if (item && item.id && referralId) {
            RemotingService.getRemoteCall(
                `api/insurance/coordinator/v2/referral/${referralId}/${kind}`,
                {referralItemId: item.id},
                versions => {
                    dialog({
                        title: title,
                        component: <VersionModalV2 versions={versions}/>
                    });
                }
            );
        }
    }

    openRequestVersionsDialog = (item) => {
        this.openVersionsDialog(item, "request-versions", "Request Versions");
    }

    openAuthorizationVersionsDialog = (item) => {
        this.openVersionsDialog(item, "authorization-versions", "Authorization Versions");
    }

    cptTemplate = (item) => {
        return (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {item.cpt
                    ? <HoverableDescriptionBox header={item.cpt.cptCode} description={item.cpt.description || item.cpt.cptCode}/>
                    : <span>-</span>
                }
            </div>
        );
    }

    netTemplate = (item) => {
        const net = item.cpt?.net;
        return (
            <div style={{ textAlign: 'center', fontSize: '12px' }}>
                {net != null ? net.toFixed(2) : '-'}
            </div>
        );
    }

    amountTemplate = (item) => {
        const net = item.cpt?.net;
        const sessions = item.noOfRequestedSessions;
        const amount = net != null && sessions != null ? net * sessions : null;
        return (
            <div style={{ textAlign: 'center', fontSize: '12px' }}>
                {amount != null ? amount.toFixed(2) : '-'}
            </div>
        );
    }

    statusTemplate = (item) => {
        const { readOnly } = this.props;
        const disabled = readOnly;
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PrimeDropdown
                    optionLabel="name"
                    optionValue="key"
                    options={DirectBillingItemStatusEnum.toArray()}
                    value={item.status}
                    onChange={(e) => this.updateReferralItem(item, 'status', e.value)}
                    appendTo={document.body}
                    disabled={disabled}
                    style={{
                        width: '100%',
                        maxWidth: '120px',
                        height: '35px',
                        fontSize: '12px',
                        opacity: disabled ? 0.6 : 1
                    }}
                />
            </div>
        );
    }

    authStatusTemplate = (item) => {
        const { readOnly } = this.props;
        const disabled = readOnly;
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PrimeDropdown
                    optionLabel="name"
                    optionValue="key"
                    options={DirectBillingItemAuthorizationStatusEnum.toArray()}
                    value={item.authorizationStatus}
                    onChange={(e) => this.updateReferralItem(item, 'authorizationStatus', e.value)}
                    appendTo={document.body}
                    disabled={disabled}
                    style={{
                        width: '100%',
                        maxWidth: '120px',
                        height: '35px',
                        fontSize: '12px',
                        opacity: disabled ? 0.6 : 1
                    }}
                />
            </div>
        );
    }

    coPayTemplate = (item) => {
        const { readOnly } = this.props;
        const options = EnumCoPayUnit.keys().map(key => ({ value: key, label: EnumCoPayUnit[key] }));
        const selectedUnit = options.find(o => o.value === item.coPayUnit) || null;
        const notMandatory = this.isItemUnauthorized(item);
        const disabled = readOnly;
        return (
            <div style={{display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px'}}>
                    <span style={{minWidth: '45px', fontWeight: 600}}>Type:</span>
                    <FormField ref={ff => ff && this.formFields.push(ff)} required disabled={notMandatory} validateOn={item.coPayUnit}>
                        <Select
                            options={options}
                            value={selectedUnit}
                            isDisabled={disabled}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            onChange={(opt) => this.updateReferralItem(item, 'coPayUnit', opt ? opt.value : null)}
                            styles={{
                                control: (base) => ({...base, minHeight: '28px', height: '28px', fontSize: '12px', width: '70px'}),
                                valueContainer: (base) => ({...base, padding: '0 6px', height: '28px'}),
                                indicatorsContainer: (base) => ({...base, height: '28px'}),
                                dropdownIndicator: (base) => ({...base, padding: '0 2px'}),
                                clearIndicator: (base) => ({...base, padding: '0 2px'}),
                                input: (base) => ({...base, margin: 0, padding: 0}),
                                option: (base) => ({...base, fontSize: '12px'}),
                            }}
                        />
                    </FormField>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px'}}>
                    <span style={{minWidth: '45px', fontWeight: 600}}>Amount:</span>
                    <FormField ref={ff => ff && this.formFields.push(ff)} required disabled={notMandatory} validateOn={item.coPay}>
                        <NumberInput
                            value={item.coPay}
                            min={0}
                            step={0.01}
                            disabled={disabled}
                            style={{
                                width: '70px',
                                height: '28px',
                                textAlign: 'center',
                                fontSize: '12px',
                                opacity: disabled ? 0.6 : 1
                            }}
                            onChange={(value) => this.updateReferralItem(item, 'coPay', value)}
                        />
                    </FormField>
                </div>
            </div>
        );
    }


    requestedSessionsTemplate = (item) => {
        const { readOnly } = this.props;
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <NumberInput
                    value={item.noOfRequestedSessions}
                    min={0}
                    disabled={readOnly}
                    style={{width: '70px', height: '28px', textAlign: 'center', fontSize: '12px'}}
                    onChange={(value) => this.updateReferralItem(item, 'noOfRequestedSessions', value)}
                />
            </div>
        );
    }

    approvedSessionsTemplate = (item) => {
        const { readOnly } = this.props;
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <FormField ref={ff => ff && this.formFields.push(ff)} required validateOn={item.noOfApprovedSessions}>
                    <NumberInput
                        value={item.noOfApprovedSessions}
                        min={0}
                        disabled={readOnly}
                        style={{width: '70px', height: '28px', textAlign: 'center', fontSize: '12px'}}
                        onChange={(value) => this.updateReferralItem(item, 'noOfApprovedSessions', value)}
                    />
                </FormField>
            </div>
        );
    }

    denialCodeTemplate = (item) => {
        const { readOnly } = this.props;
        const disabled = readOnly;
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <TextInput
                    value={item.denialCode || ''}
                    disabled={disabled}
                    style={{
                        width: '100%',
                        maxWidth: '100px',
                        height: '35px',
                        textAlign: 'center',
                        fontSize: '12px',
                        opacity: disabled ? 0.6 : 1
                    }}
                    onChange={(value) => this.updateReferralItem(item, 'denialCode', value)}
                />
            </div>
        );
    }

    automationTemplate = (item) => {
        return (
            <div style={{ padding: '6px', fontSize: '11px' }}>
                <Row className="g-1">
                    <Col xs={6}>
                        <Button 
                            variant="link" 
                            size="sm" 
                            style={{ padding: '3px 6px', fontSize: '11px', textDecoration: 'underline' }}
                            onClick={() => this.openObservationsDialog(item)}
                            disabled={!item || !item.id}
                        >
                            Observations <FontAwesomeIcon icon="paperclip" />
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button 
                            variant="link" 
                            size="sm" 
                            style={{ padding: '3px 6px', fontSize: '11px', textDecoration: 'underline' }}
                            onClick={() => this.openObservationFromInsuranceDialog(item)}
                            disabled={!item || !item.id}
                        >
                            Insurance Obs <FontAwesomeIcon icon="paperclip" />
                        </Button>
                    </Col>
                </Row>
                <Row className="g-1">
                    <Col xs={6}>
                        <Button 
                            variant="link" 
                            size="sm" 
                            style={{ padding: '3px 6px', fontSize: '11px', textDecoration: 'underline' }}
                            onClick={() => this.openResubmissionsDialog(item)}
                            disabled={!item || !item.id}
                        >
                            Resubmissions <FontAwesomeIcon icon="paperclip" />
                        </Button>
                    </Col>
                    <Col xs={6}>
                        <Button 
                            variant="link" 
                            size="sm" 
                            style={{ padding: '3px 6px', fontSize: '11px', textDecoration: 'underline' }}
                            onClick={() => this.openRequestVersionsDialog(item)}
                            disabled={!item || !item.id || !this.props.referral?.id}
                        >
                            Request Versions <FontAwesomeIcon icon="paperclip" />
                        </Button>
                    </Col>
                </Row>
                <Row className="g-1">
                    <Col xs={6}>
                        <Button 
                            variant="link" 
                            size="sm" 
                            style={{ padding: '3px 6px', fontSize: '11px', textDecoration: 'underline' }}
                            onClick={() => this.openAuthorizationVersionsDialog(item)}
                            disabled={!item || !item.id || !this.props.referral?.id}
                        >
                            Auth Versions <FontAwesomeIcon icon="paperclip" />
                        </Button>
                    </Col>
                    <Col xs={6}>
                        {/* Empty column for alignment */}
                    </Col>
                </Row>
            </div>
        );
    }

    render() {
        this.formFields = [];
        const { referral, readOnly } = this.props;
        const { referralItems, selectedItems } = this.state;

        const { cptSearchVisible, cptSuggestions } = this.state;

        return (
            <div className="referral-items-expansion">
                <h6 className="expansion-header">
                    Referral Items for {referral.patient?.firstName} {referral.patient?.lastName} - {referral.referenceNo}
                </h6>
                <DataTable
                    value={referralItems}
                    selection={readOnly ? null : selectedItems}
                    onSelectionChange={readOnly ? undefined : this.handleSelectionChange}
                    className="nested-referral-items-table"
                    emptyMessage="No referral items found"
                    scrollable
                    scrollHeight="400px"
                    style={{ width: '100%' }}
                >
                    { !readOnly && (
                        <Column
                            selectionMode="multiple"
                            headerStyle={{width: '5%', minWidth: '50px', textAlign: 'center'}}
                            style={{width: '5%', minWidth: '50px', textAlign: 'center'}}
                        />
                    )}
                    <Column
                        header="CPT Code"
                        body={this.cptTemplate}
                        headerStyle={{width: '8%', minWidth: '80px'}}
                        style={{width: '8%', minWidth: '80px'}}
                    />
                    <Column
                        header="Req. Sessions"
                        body={this.requestedSessionsTemplate}
                        headerStyle={{width: '8%', minWidth: '90px', textAlign: 'center'}}
                        style={{width: '8%', minWidth: '90px'}}
                    />
                    <Column
                        header="Auth. Sessions"
                        body={this.approvedSessionsTemplate}
                        headerStyle={{width: '8%', minWidth: '90px', textAlign: 'center'}}
                        style={{width: '8%', minWidth: '90px'}}
                    />
                    <Column
                        header="Net"
                        body={this.netTemplate}
                        headerStyle={{width: '6%', minWidth: '60px', textAlign: 'center'}}
                        style={{width: '6%', minWidth: '60px'}}
                    />
                    <Column
                        header="Amount"
                        body={this.amountTemplate}
                        headerStyle={{width: '7%', minWidth: '70px', textAlign: 'center'}}
                        style={{width: '7%', minWidth: '70px'}}
                    />
                    <Column
                        header="Status"
                        body={this.statusTemplate}
                        headerStyle={{width: '15%', minWidth: '130px'}}
                        style={{width: '15%', minWidth: '130px'}}
                    />
                    <Column
                        header="Co-Pay"
                         body={this.coPayTemplate} 
                         headerStyle={{width: '15%', minWidth: '90px'}}
                         style={{width: '15%', minWidth: '90px'}}
                     />
                     <Column 
                         header="Auth Status" 
                         body={this.authStatusTemplate} 
                         headerStyle={{width: '15%', minWidth: '130px'}} 
                         style={{width: '15%', minWidth: '130px'}}
                     />
                     <Column 
                         header="Denial Code" 
                         body={this.denialCodeTemplate} 
                         headerStyle={{width: '10%', minWidth: '100px'}}
                         style={{width: '10%', minWidth: '100px'}}
                     />
                     <Column 
                         header="Obs/XMLs"
                         body={this.automationTemplate} 
                         headerStyle={{width: '20%', minWidth: '150px', textAlign: 'center'}} 
                         style={{width: '20%', minWidth: '150px', textAlign: 'center'}}
                     />
                </DataTable>
                <div style={{
                    borderTop: '1px solid #e0e0e0',
                    marginTop: '10px',
                    paddingTop: '15px',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <SplitButton
                            id="referralPriorRequestActions"
                            variant="success"
                            title="Submit Prior Request"
                            disabled={readOnly || selectedItems.length === 0}
                            onClick={this.handleSubmitPriorRequest}
                        >
                            <Dropdown.Item onClick={this.handleExtendPriorRequest}>Extend Validity</Dropdown.Item>
                            <Dropdown.Item onClick={this.handleCancelPriorRequest}>Cancel Prior Request</Dropdown.Item>
                            <Dropdown.Item onClick={this.handleSubmitNewRequest}>Submit New Request</Dropdown.Item>
                        </SplitButton>
                        <button
                            onClick={this.handleDeleteSelected}
                            disabled={readOnly || selectedItems.length === 0}
                            className="btn btn-danger"
                            style={{
                                padding: '8px 20px',
                                fontSize: '14px',
                                fontWeight: '500',
                                opacity: (readOnly || selectedItems.length === 0) ? 0.6 : 1,
                                cursor: (readOnly || selectedItems.length === 0) ? 'not-allowed' : 'pointer',
                            }}
                        >
                            Delete
                        </button>
                        <button
                            onClick={() => this.setState({ cptSearchVisible: !cptSearchVisible })}
                            disabled={readOnly}
                            className="btn btn-outline-primary"
                            style={{
                                padding: '8px 20px',
                                fontSize: '14px',
                                fontWeight: '500',
                                opacity: readOnly ? 0.6 : 1,
                                cursor: readOnly ? 'not-allowed' : 'pointer',
                            }}
                        >
                            Add CPT
                        </button>
                        <InsuranceDocuments
                            item={referral}
                            onClaimFormStatusChange={(newStatus) => this.props.onReferralChange(referral.id, 'claimFormStatus', newStatus)}
                            onMedicalReportStatusChange={(newStatus) => this.props.onReferralChange(referral.id, 'medicalReportStatus', newStatus)}
                        />
                    </div>
                    {cptSearchVisible && (
                        <div style={{ marginTop: '10px' }}>
                            <AutoComplete
                                placeholder="Search CPT code..."
                                minLength={2}
                                field="cptCode"
                                suggestions={cptSuggestions}
                                completeMethod={this.handleCptSearch}
                                itemTemplate={(cpt) => <span>{cpt.cptCode} - {cpt.description}</span>}
                                onSelect={this.handleCptSelected}
                                autoFocus
                                inputStyle={{ width: '280px', fontSize: '12px', height: '32px' }}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
